import { CanActivateFn, Router } from '@angular/router';
import { UserAuthenticationService } from '../services/user-authentication/user-authentication.service';
import { inject } from '@angular/core';
import { WorkspaceService } from '../services/workspace/workspace.service';

export const deepLinkModalGuard: CanActivateFn = async () => {
    const authService = inject(UserAuthenticationService);
    const workspaceService = inject(WorkspaceService);
    const router = inject(Router);
  
    let isAuthenticated = await authService.verifyIfUserIsAuthenticatedAsync();
    while (isAuthenticated === undefined) {
      await new Promise(resolve => setTimeout(resolve, 500));
      isAuthenticated = await authService.verifyIfUserIsAuthenticatedAsync();
    }
  
    // Step 1: Check if user is authenticated, if not redirect to login
    if (!isAuthenticated) {
      authService.redirectToLogin();
      return false;
    }
  
    let currentWorkspace = workspaceService.getCurrentUserWorkspace();
    while (currentWorkspace === undefined) {
      await new Promise(resolve => setTimeout(resolve, 500));
      currentWorkspace = workspaceService.getCurrentUserWorkspace();
    }
  
    // Step 2: Check if user has permissions to install/update/apply products, if not redirect to no-permissions modal
    if (!workspaceService.canInstallUpdateApplyProducts()) {
      router.navigate([{ outlets: { modal: "no-permissions" } }], { skipLocationChange: true })
      return false;
    }
  
    return true;
};
